// import {store1} from '../store/index's

var DataStore = require('../store');
var store = DataStore.default

const fetchPOST = () => {
  return store.state.kamio
}


const getUsulan = () => {
  fetch(store.state.url.URL_DM_TRIWULAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_triwulan = res_data
    // console.log(res_data)
  })
}

const getJnsPenerimaan = () => {
  fetch(store.state.url.URL_DM_JENIS_PENERIMA + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_penerimaan = res_data
    // console.log(res_data)
  })
}

const getKelasPenerima = () => {
  fetch(store.state.url.URL_DM_KELAS_PENERIMA + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kelas_penerima = res_data
    // console.log(res_data)
  })
}

const getKelas = () => {
  fetch(store.state.url.URL_DM_KELAS + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kelas = res_data
    // console.log(res_data)
  })
}

const getMapel = (id) => {
  fetch(store.state.url.URL_DM_MAPEL + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        kelas_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_mapel = res_data
    // console.log(res_data)
  })
}

const getMateriAjar = () => {
  fetch(store.state.url.URL_DM_MATERI_AJAR + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // kelas_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_materi_ajar = res_data
    // console.log(res_data)
  })
}

const getBahanAjar = () => {
  fetch(store.state.url.URL_DM_BAHAN_AJAR + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // kelas_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_bahan_ajar = res_data
    // console.log(res_data)
  })
}

const getKecamatan = () => {
  fetch(store.state.url.URL_WILAYAH + "list_kecamatan", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        // unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kecamatan = res_data
    // console.log(res_data)
  })
}

const getDesKel = (id) => {
  fetch(store.state.url.URL_WILAYAH + "list_des_kel", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        kecamatan_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_des_kel = res_data
    // console.log(res_data)
  })
}

const getWaliKelas = (id) => {
  fetch(store.state.url.URL_DM_SISWA + "list_guru", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_wali_kelas = res_data
    // console.log(res_data)
  })
}

const getJenjang = (id) => {
  fetch(store.state.url.URL_DM_JENJANG + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jenjang = res_data
    // console.log(res_data)
  })
}

const getMdlPembelajaran = () => {
  fetch(store.state.url.URL_DM_MDL_PEMBELAJARAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        
      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_mdl_pembelajaran = res_data
    // console.log(res_data)
  })
}

const getMtdPembelajaran = () => {
  fetch(store.state.url.URL_DM_MTD_PEMBELAJARAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_mtd_pembelajaran = res_data
    // console.log(res_data)
  })
}

const getPenilaian = () => {
  fetch(store.state.url.URL_DM_PENILAIAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_penilaian = res_data
    // console.log(res_data)
  })
}

const getPendampingan = () => {
  fetch(store.state.url.URL_DM_PENDAMPINGAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_pendampingan = res_data
    // console.log(res_data)
  })
}

const getTugas = () => {
  fetch(store.state.url.URL_DM_TUGAS + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_tugas = res_data
    // console.log(res_data)
  })
}

const getKegiatanLayanan = () => {
  fetch(store.state.url.URL_DM_KEGIATAN_LAYANAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kegiatan_layanan = res_data
    // console.log(res_data)
  })
}

const getJnsLayanan = () => {
  fetch(store.state.url.URL_DM_JENIS_LAYANAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_layanan = res_data
    // console.log(res_data)
  })
}

const getBangunan = (id) => {
  fetch(store.state.url.URL_BANGUNAN+ "list_bangunan", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_bangunan = res_data
    // console.log(res_data)
  })
}

const getRuang = (id) => {
  fetch(store.state.url.URL_RUANG+ "list_ruang", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja_id : id,

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_ruang = res_data
    console.log(res_data)
  })
}




module.exports = {
  fetchPOST: fetchPOST,
  getUsulan: getUsulan,
  getJnsPenerimaan: getJnsPenerimaan,
  getKelasPenerima: getKelasPenerima,
  getKelas: getKelas,
  getMapel: getMapel,
  getMateriAjar: getMateriAjar,
  getBahanAjar: getBahanAjar,
  getKecamatan: getKecamatan,
  getDesKel: getDesKel,
  getWaliKelas: getWaliKelas,
  getJenjang: getJenjang,
  getMdlPembelajaran: getMdlPembelajaran,
  getMtdPembelajaran: getMtdPembelajaran,
  getPenilaian: getPenilaian,
  getPendampingan: getPendampingan,
  getTugas: getTugas,
  getKegiatanLayanan: getKegiatanLayanan,
  getJnsLayanan: getJnsLayanan,
  getBangunan: getBangunan,
  getRuang: getRuang,
}